






























import Vue from 'vue';
import StudioLogo from '@/web/components/navigation/StudioLogo';
import { mapGetters } from 'vuex';
import { style } from '@/web/utils/stripe';
import { errorToMessage } from '@/core/utils/errors';
import TipJarModal from '@/web/components/settings/TipJarModal.vue';
import HMModalContainer from '@/web/components/common/HMModalContainer.vue';

export default Vue.extend({
  name: 'StudioTips',
  components: { TipJarModal, StudioLogo },
  data() {
    return {
      stripeCompleted: false,
      stripeError: false,
      inProgress: false,
      jarSelected: null,
      tipAmount: null,
      customTipAmount: null,
      tipSuccessful: false,
      modalStage: 'select',
      anonUserEmail: null,
    };
  },
  computed: {
    ...mapGetters({
      currentStudio: 'studio/currentStudio',
      role: 'user/role',
    }),
    tipButtonText() {
      return this.tipAmount
        ? this.$t('STUDIO.BUTTON.TIP_X_AMOUNT', {
            tipAmount: this.$formatCurrency(
              this.tipAmount || 0,
              this.currentStudio.currency
            ),
          })
        : this.$t('STUDIO.BUTTON.SELECT_AN_AMOUNT');
    },
    headerImage() {
      return (
        this.currentStudio?.cover_photo?.storage_url ??
        this.currentStudio?.cover_photo?.embedded_image_url
      );
    },
  },
  methods: {
    goToStudio() {
      this.$router.push({ name: 'studio-home' });
    },
  },
  mounted() {
    if (!this.currentStudio?.tip_jar_enabled) {
      this.goToStudio();
    }
  },
});
